'use client'

import { useEffect, useRef } from 'react'

import { createSessionCookie } from './session-cookie'

/**
 * Creates the API session cookie when a user signs in with Firebase: the
 * Firebase ID token is exchanged for an `HttpOnly` cookie via
 * `POST /auth/session`, which is then sent automatically with every API
 * request (axios `withCredentials`) — so the session is shared across the
 * apps.
 *
 * Creation is attempted once per user per page session; renewing the cookie
 * afterwards is handled by the refresh interceptor (see
 * `setupSessionCookieRefresh`).
 */
export const useSessionCookie = (user: { uid: string } | null) => {
	const createdForUidRef = useRef<string | null>(null)

	useEffect(() => {
		const uid = user?.uid ?? null

		if (!uid || createdForUidRef.current === uid) return

		createdForUidRef.current = uid
		void createSessionCookie()
	}, [user])
}
